import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { encryptStorage } from '../../../utils/EncryptStorage';
import {
  formatRut,
  isValidRut,
  formatSerialNumber,
  isValidSerialNumber,
} from '../../../utils/index';
import { TipoProducto } from '../../../utils/TipoProducto';
import { verificacionActions } from '../../../application/actions/verificacion';
import TagManagerUtils from '../../../utils/TagManagerUtils';
import VerificacionTemplate from '../../components/templates/Verificacion';
import Botonera from '../../components/atoms/Footer';
import { properties } from '../../../utils/properties';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA;

const Step1 = () => {
  encryptStorage.setItem('p', '/');
  encryptStorage.setItem('o', 'SA');
  const recaptchaInstance = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  // const [isVerifiedCaptcha, setIsVerifiedCaptcha] = useState(false);
  const [tokenCaptcha, setTokenCaptcha] = useState();
  const [state, setState] = useState({
    menuPosition: 1,
    checkbock: false,
    arraydeBotones: [
      { nameUno: properties.pasos.paso1.aceptarButton, nameDos: properties.volverCoopeuch },
    ],
  });
  const [botoneraStates, setBotonera] = useState({
    botonUno: true,
    BotonDos: false,
  });

  const [inputRut, setInputRut] = useState({
    rut: '',
    texto: [{ type: 'assist', text: '' }],
    checkRut: false,
  });

  const [inputNumeroSerie, setInputNumeroSerie] = useState({
    nDeSerie: '',
    textoSerie: [{ type: 'assist', text: '' }],
    checkNSerie: false,
  });

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);

  const volverACoopeuch = () => {
    window.location.href = properties.urlHomeCoopeuch;
  };

  const autorizo = (e) => {
    if (e === 'false') {
      setState({ ...state, checkbock: true });
      setBotonera({ ...botoneraStates, botonUno: false });
    } else {
      setState({ ...state, checkbock: false });
    }
  };

  const obtenerRut = (e) => {
    const rut = e;
    if (rut.length === 0) {
      setInputRut({
        ...inputRut,
        texto: [{ type: 'assist', text: '' }],
        checkRut: false,
        rut: formatRut(e),
      });
    } else if (isValidRut(e)) {
      setInputRut({
        ...inputRut,
        texto: [{ type: 'assist', text: '' }],
        checkRut: true,
        rut: formatRut(e),
      });
    } else {
      setInputRut({
        ...inputRut,
        texto: [{ type: 'error', text: properties.pasos.paso1.errorRut }],
        checkRut: false,
        rut: formatRut(e),
      });
    }
  };

  const obtenerNumeroSerie = (e) => {
    const formatted = formatSerialNumber(e);
    if (formatted.length === 0) {
      setInputNumeroSerie({
        ...inputNumeroSerie,
        textoSerie: [{ type: 'assist', text: '' }],
        checkNSerie: false,
        nDeSerie: formatted,
      });
    } else if (isValidSerialNumber(formatted)) {
      setInputNumeroSerie({
        ...inputNumeroSerie,
        textoSerie: [{ type: 'assist', text: '' }],
        checkNSerie: true,
        nDeSerie: formatted,
      });
    } else {
      setInputNumeroSerie({
        ...inputNumeroSerie,
        textoSerie: [{ type: 'error', text: properties.pasos.paso1.errorNroSerie }],
        checkNSerie: false,
        nDeSerie: formatted,
      });
    }
  };

  const verificar = async () => {
    const { rut } = inputRut;
    const { nDeSerie } = inputNumeroSerie;
    const rutInput = rut.replaceAll('.', '').replace('-', '');
    const nSerieInput = nDeSerie.replaceAll('.', '');

    const params = {
      rut: rutInput,
      serie: nSerieInput,
      tokenCaptcha: tokenCaptcha,
    };

    dispatch(verificacionActions.verificacion(params));
  };

  const urlFuturaTarjeta = () => {
    const { data } = storeDataVerificacion;
    const { tipoTarjeta } = data;
    let nuevoPath = '';
    if (tipoTarjeta === TipoProducto.black) {
      nuevoPath = '/tu-futura-tarjeta/finalizada/black';
    } else {
      nuevoPath = '/tu-futura-tarjeta/finalizada/gold';
    }
    encryptStorage.setItem('p', nuevoPath);
    history.push(nuevoPath);
  };

  // TagManagerUtils
  useEffect(() => {
    TagManagerUtils.vpvMetodo('vpv', 'solicitud-tarjeta-credito/paso1', 'No socio');
  }, []);

  const { menuPosition, checkbock, arraydeBotones } = state;
  const { BotonDos } = botoneraStates;
  const { rut, texto, checkRut } = inputRut;
  const { nDeSerie, textoSerie, checkNSerie } = inputNumeroSerie;

  useEffect(() => {
    const { code, data } = storeDataVerificacion;
    if (code !== undefined) {
      switch (code) {
        case -1:
          window.localStorage.setItem('paso', '/');
          history.push('/error-conexion');
          break;
        case 0: {
          // const nuevoPath ='/datos-personales' ;
          // const nuevaEtapa = 'DP';
          const { socio } = data;
          const nuevoPath = socio ? '/datos-personales' : '/tu-futura-tarjeta/hazte-socio';
          const nuevaEtapa = socio ? 'DP' : 'HS';
          encryptStorage.setItem('p', nuevoPath);
          encryptStorage.setItem('o', nuevaEtapa);
          history.push(nuevoPath);
          break;
        }
        case 5: {
          const { tipoTarjeta } = data;
          let nuevoPath = '';
          if (tipoTarjeta === TipoProducto.gold) {
            nuevoPath = '/verificacion/error/usuario-con-tc/gold';
          } else {
            nuevoPath = '/verificacion/error/usuario-con-tc/black';
          }
          history.push(nuevoPath);
          break;
        }
        case 6:
          urlFuturaTarjeta();
          break;
        case 7: {
          const { tipoTarjeta } = data;
          let nuevoPath = '';
          if (tipoTarjeta === TipoProducto.gold) {
            nuevoPath = '/tu-futura-tarjeta/mastercard/gold';
          } else if (tipoTarjeta === TipoProducto.black) {
            nuevoPath = '/tu-futura-tarjeta/mastercard/black';
          } else {
            nuevoPath = '/tu-futura-tarjeta/dale';
          }
          encryptStorage.setItem('p', nuevoPath);
          history.push(nuevoPath);
          break;
        }
        case 32: {
          const nuevoPath = '/error/cedula-no-valida';
          encryptStorage.setItem('p', nuevoPath);
          history.push(nuevoPath);
          break;
        }
        default:
          history.push('/error');
          break;
      }
    }
  }, [storeDataVerificacion]);

  const onChange = () => {
    if (recaptchaInstance.current.getValue()) {
      setTokenCaptcha(recaptchaInstance.current.getValue());
    }
  };

  const onExpired = () =>{
    setTokenCaptcha(null);
 }

 const onErrored = ()=>{
   setTokenCaptcha(null);
 }
  return (
    <>
      <VerificacionTemplate
        activeMenu={menuPosition}
        autorizoFunction={autorizo}
        setAutorizo={checkbock}
        valueInputRut={rut}
        mensajeInputRut={texto}
        valueNdeSerie={nDeSerie}
        mensajeInputSerie={textoSerie}
        obtenerRutInput={obtenerRut}
        obtenerNumeroSerieInput={obtenerNumeroSerie}
      />
      <ReCAPTCHA
        ref={recaptchaInstance}
        onChange={()=>onChange()}
        onExpired={()=>onExpired()}
        onErrored={()=>{onErrored()}}
        sitekey={RECAPTCHA_KEY}
        badge="bottomleft"
        size="normal"
      />
      <Botonera
        tituloboton={arraydeBotones}
        verificarFunction={verificar}
        volverHome={volverACoopeuch}
        estadoBotonUno={checkRut && checkNSerie && checkbock && tokenCaptcha}
        estadoBotonDos={BotonDos}
        nombreDinamicoResponsive={false}
        activeMenu={menuPosition}
      />
    </>
  );
};

export default Step1;
